export const pathAssetsBase: string = import.meta.env.VITE_APP_PATH_ASSETS ||
    'https://appspowerplaymanager.vshcdn.net/images/winter-sports/minigame/'
export const pathAssetsBaseNew: string = import.meta.env.VITE_APP_PATH_ASSETS_NEW ||
    'https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/'
export const pathAssets = `${pathAssetsBase}cross-country`
export const pathAssetsKayak = `${pathAssetsBaseNew}kayak`
export const pathAssetsGlobal = `${pathAssetsBaseNew}global`
export const pathAssetsCoreUi = 'https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui'
